<template>
  <div>
    <div class="wrapper">
      <div class="container mt-6">
        <div class="columns is-multiline is-gapless is-vcentered">
          <div class="column is-12 mt-6 mb-2 has-text-left">
            <h2 class="title is-1 centerText">{{ gym.name }}</h2>
          </div>
          <div class="column is-8">
            <h2 class="subtitle is-4 centerText">{{ gym.address }}</h2>
          </div>
          <div class="column is-4 has-text-right">
            <div class="ratingBar">
              <RatingBar
                v-if="renderRating"
                :rating="parseFloat(gym.review_avg)"
                :reviews_number="parseInt(gym.review_count)"
                :gym_id="parseInt(gym.gym_id)"
                @scrollToCreate="scrollToCreate"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="buttonBanner">
        <div class="container">
          <div class="button-flex">
            <button
              v-if="backToSearchButton"
              class="button search-button slide-left"
              @click="$router.go(-1)"
            >Back to search</button>
            <button
              v-else
              class="button search-button slide-left"
              @click="$router.push({ path: '/' })"
            >Home</button>
            <div class="mobile-w100">
              <button
                class="button search-button slide-left"
                @click="freeFormPass()"
              >Request a free pass</button>
              <button
                class="button search-button slide-left"
                @click="addReferralOpenSite(gym.website_link, gym.gym_id)"
              >Visit Website</button>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <Carousel v-if="renderCarousel && gym" :images="images" />
      </div>
      <DealBanner
        v-if="renderDeals && gym.website_link"
        :cards="gym.price_packages"
        :website="gym.website_link"
      />
      <div class="wrapper">
        <div class="container">
          <div class="columns is-gapless mt-4">
            <div class="column mt-2rem">
              <h2 class="title gymHeader">About {{ gym.name }}</h2>
              <hr class="m-0" />
              <div class="p-1rem content-size" v-html="gym.description"></div>
              <div class="m2rema">
                <FacilityList id="facilities" class="facilities" :facilities="gym.facilities" />
              </div>
              <h2 class="title gymHeader">Opening Times</h2>
              <hr class="m-0" />
              <div class="opening-time-wrapper">
              <div
                class="columns is-gapless is-mobile openingTimesContainer mb-4 p-2"
                v-for="(dayTime, index) in sortOpeningTimes"
                :key="index"
              >
                <div class="column openingTimes is-narrow">
                  <p class="pt-1 pb-1 pl-0 pr-0">
                    <b>{{dayTime.day}}:</b>
                  </p>
                </div>
                <div class="column openingTimes">
                  <div v-for="(time, index) in dayTime.hours" :key="index" class="pt-1 pb-1 pl-1 time">
                    <div v-if="time.length > 2 && time !==  '00:00:00~00:00:00' && time !== 'CLOSED'">
                      <span class="tag is-large">{{formatTime(time)[0]}}</span>
                      <span>-</span>
                      <span class="tag is-large">{{formatTime(time)[1]}}</span>
                    </div>
                    <span class="tag is-large" v-else>{{formatTime(time)}}</span>
                  </div>
                </div>
              </div>
              </div>
            </div>
            <div class="column mt-2rem">
              <div v-if="mapLink">
                <h2 class="title gymHeader">Location</h2>
                <hr class="m-0" />
                <div class="has-text-centered mapContainer">
                  <iframe class="map" frameborder="0" :src="mapLink" allowfullscreen></iframe>
                </div>
              </div>
              <div>
                <ReviewsCard
                  :gymId="parseInt(gym.gym_id)"
                  :gymName="gym.name"
                  :website="gym.website_link"
                  :active="createReview"
                  @closeReview="createReview = false"
                />
              </div>
              <div class="container has-text-centered mt-4 pb-4">
                <a
                  class="button search-button is-large slide-left visitWebsiteButton"
                  @click="addReferralOpenSite(gym.website_link, gym.gym_id)"
                >Visit their Website</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FreePassForm />
  </div>
</template>

<script>
import RatingBar from "@/components/molecules/RatingBar.vue";
import Carousel from "@/components/organisms/Carousel.vue";
import FacilityList from "@/components/molecules/FacilityList.vue";
import FreePassForm from "@/components/organisms/FreePassForm.vue";
import DealBanner from "@/components/organisms/DealBanner.vue";
import ReviewsCard from "@/components/molecules/ReviewsCard";
var moment = require("moment");
import { mapMutations, mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      createReview: false,
      renderRating: true,
      renderCarousel: true,
      renderDeals: true
    };
  },
  computed: {
    ...mapState(["gymId", "backToSearchButton"]),
    gym() {
      return this.$store.state.gym;
    },
    images() {
      if (this.gym) {
        if (typeof this.gym.images === "string") {
          return JSON.parse(this.gym.images);
        }
        return this.gym.images;
      }
      return null;
    },
    mapLink() {
      let link = this.gym.map_link;
      if (link) {
        const split = link.split('"');
        if (split[1] != null) return split[1];
      }
      return "";
    },
    sortOpeningTimes() {
      if (this.gym.opening_times) {
        const sortTable = {
          monday: 1,
          tuesday: 2,
          wednesday: 3,
          thursday: 4,
          friday: 5,
          saturday: 6,
          sunday: 7
        };

        let openingTimes = Object.keys(this.gym.opening_times).map(day => {
          return { day: day, hours: this.gym.opening_times[day] };
        });
        openingTimes = openingTimes.sort((a, b) => {
          return (
            sortTable[a.day.toLowerCase()] - sortTable[b.day.toLowerCase()]
          );
        });

        return openingTimes.map(day => {
          return {
            day: day.day[0].toUpperCase() + day.day.slice(1, day.day.length),
            hours: day.hours.length ? day.hours : ["CLOSED"]
          };
        });
      }
      return null;
    }
  },
  methods: {
    ...mapMutations(["storeGymId"]),
    ...mapActions(["findGymById", "addReferral"]),
    addReferralOpenSite(website, gymId) {
      if (website.indexOf("http") === -1) {
        website = "http://" + website;
      }
      window.open(
        website,
        "_blank" // <- This is what makes it open in a new window.
      );
      this.addReferral(gymId);
    },
    formatTime(time) {
      if (time === "CLOSED") {
        return time;
      } else {
        let times = time.split("~");
        times = times.map(time => {
          return moment(time, "hh:mm").format("h:mm a");
        });
        if (times[0] == "12:00 am" && times[1] == "12:00 am") {
          return "Open 24 hours";
        } else {
          return times;
        }
      }
    },
    freeFormPass() {
      let selected_gym = {
        gym_id: this.gym.gym_id,
        gym_name: this.gym.name
      };
      this.$store.commit("selectFreePassGym", selected_gym);
      this.$store.commit("freeFormPassSwitch");
    },
    scrollToCreate() {
      let element = document.querySelector("#create-review-button");
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });
      element.click();
    }
  },
  props: {
    reviews: Object
  },
  components: {
    RatingBar,
    Carousel,
    FreePassForm,
    DealBanner,
    FacilityList,
    ReviewsCard
  },
  async mounted() {
    this.renderRating = false;
    this.renderCarousel = false;
    this.renderDeals = false;
    this.storeGymId(this.$route.params.id);
    await this.findGymById();
    this.renderRating = true;
    this.renderCarousel = true;
    this.renderDeals = this.gym.price_packages ? this.gym.price_packages.some(
      price_package => price_package.description && price_package.name
    ) : true;
    setTimeout(() => {
      if (this.$route.hash) {
        let element = document.querySelector(this.$route.hash);
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
        element.click();
      }
    }, 500);
  }
};
</script>

<style lang="scss" scoped>
.content-size {
  font-size: 1.5rem;
}

.resetCss {
  all: initial;
  * {
    all: unset;
  }
}

.button {
  margin: 0.25rem;
}

.button-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.buttonBanner {
  width: 100vw;
  background: #333333;
  padding: 0.5rem;
  margin-top: 1rem;
}

.centerText {
  text-align: initial;
}

.notification-banner {
  width: 100%;
  background-color: #ff0000;
  color: white;
  padding: 0.75rem;
}

.map {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}

i {
  font-size: 2rem;
  margin: 0 2rem;
}

p,
li {
  font-size: 1.5rem !important;
}

hr {
  width: 90%;
  margin-left: 1rem;
}

@media (max-width: 768px) {
 hr {
   width: 100%;
   margin: 0;
 }
}

p,
h1 {
  padding: 1rem;
}

span {
  padding: 0.25rem;
}

h2 {
  padding: 1rem 0;
}

.mapContainer {
  position: relative;
  height: 0;
  padding-bottom: 56.25%;
  margin: 2rem;
}

.p-1rem {
  padding: 1rem;
}

.description-container {
  min-height: 10rem;
}

.header {
  text-align: right;
}

.rating-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 1rem;
}

.flex-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.mt-2rem {
  margin-top: 2rem;
}

.m2rema {
  margin: 2rem auto;
}

.right-aligned {
  text-align: right;
}

.ratingBar {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.mobile-title {
  font-size: 1.5rem;
  margin-left: 1rem;
  margin-top: 1rem;
  padding: 0;
}

.mobile-subtitle {
  font-size: 1.5rem;
  margin-left: 0.5rem;
}

.openingTimesContainer {
  margin-bottom: 2rem;
}

.openingTimesText {
  font-size: 1.5rem;
}

@media (max-width: 358px) {
    .time {
    .tag {
      padding-left: 0.25rem;
      padding-right: 0.25rem;
    }
  }
}

@media (max-width: 768px) {
  .button {
    margin: 0.25rem 0;
  }
  .header {
    text-align: left;
  }
  .mobile-w100 {
    width: 100%;
  }
  .rating-wrapper {
    align-items: flex-start !important;
    justify-content: flex-start !important;
  }
  .dayTimeTable {
    height: 3rem;
  }
  .ratingBar {
    justify-content: center;
  }
  .centerText {
    text-align: center;
  }
  .search-button {
    width: 100%;
  }
  .gymHeader {
    font-weight: 600;
    font-size: 1.5rem;
    margin: 1rem;
    padding: 0;
  }
  .visitWebsiteButton {
    margin-left: 1rem;
    margin-right: 1rem;
    width: initial;
  }
}
</style>
